export const SAVE_EMPANELMENT = "SAVE_EMPANELMENT";
export const SAVE_EMPANELMENT_SUCCESS = "SAVE_EMPANELMENT_SUCCESS";
export const SAVE_EMPANELMENT_FAILED = "SAVE_EMPANELMENT_FAILED";

export const GET_CAMS_DATA = "GET_CAMS_DATA";
export const GET_CAMS_DATA_SUCCESS = "GET_CAMS_DATA_SUCCESS";
export const GET_CAMS_DATA_FAILED = "GET_CAMS_DATA_FAILED";

export const GENERATE_EMPANEL_OTP = "GENERATE_EMPANEL_OTP";
export const GENERATE_EMPANEL_OTP_SUCCESS = "GENERATE_EMPANEL_OTP_SUCCESS";
export const GENERATE_EMPANEL_OTP_FAILED = "GENERATE_EMPANEL_OTP_FAILED";

export const VALIDATE_EMPANEL_OTP = "VALIDATE_EMPANEL_OTP";
export const VALIDATE_EMPANEL_OTP_SUCCESS = "VALIDATE_EMPANEL_OTP_SUCCESS";
export const VALIDATE_EMPANEL_OTP_FAILED = "VALIDATE_EMPANEL_OTP_FAILED";

export const REMOVE_CAMS_DATA = "REMOVE_CAMS_DATA";

export const STORE_EMPANEL_DATA = "STORE_EMPANEL_DATA";

export const GET_BANK_DETAILS = "GET_BANK_DETAILS";
export const GET_BANK_DETAILS_SUCCESS = "GET_BANK_DETAILS_SUCCESS";
export const GET_BANK_DETAILS_FAILED = "GET_BANK_DETAILS_FAILED";

export const AGENT_REGISTRATION = "AGENT_REGISTRATION";
export const AGENT_REGISTRATION_SUCCESS = "AGENT_REGISTRATION_SUCCESS";
export const AGENT_REGISTRATION_FAILED = "AGENT_REGISTRATION_FAILED";

export const VALIDATE_ARN_CODE = "VALIDATE_ARN_CODE";
export const VALIDATE_ARN_CODE_SUCCESS = "VALIDATE_ARN_CODE_SUCCESS";
export const VALIDATE_ARN_CODE_FAILED = "VALIDATE_ARN_CODE_FAILED";

export const STORE_BANK_DETAILS = "STORE_BANK_DETAILS";
export const STORE_BASIC_DETAILS = "STORE_BASIC_DETAILS";

// to store the current state of UI in bankdetails
export const STORE_BANK_STATE = "STORE_BANK_STATE";

export const STORE_EMPANELLEMENT_NOMINEE_DETAILS = "STORE_EMPANELLEMENT_NOMINEE_DETAILS";

export const STORE_CAMS_DETAILS = "STORE_CAMS_DETAILS";


